import React from "react";
import CalculatorResultsSummary from "./CalculatorResultsSummary";

const CalculatorResults = ({ form }) => {
  return (
    <div className="calculator-results">
      <CalculatorResultsSummary form={{form}}/>
      <div className="results-content">
      </div>
    </div>
  );
};

export default CalculatorResults;
